import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './AboutEcosystem.css';

const ecosystemItems = [
  {
    name: 'ProfitYo Finance',
    category: 'Finance',
    description:
      'Accounting, bookkeeping, tax, and financial solutions that help businesses build stronger foundations and make informed decisions.',
    icon: FiIcons.FiBarChart2,
    tone: 'gold',
    position: 'ecosystem-card-main'
  },
  {
    name: 'Burning Papers',
    category: 'Lifestyle',
    description:
      'A lifestyle brand focused on transformation, character, personal growth, and long-term thinking.',
    icon: FiIcons.FiFeather,
    tone: 'terracotta',
    position: 'ecosystem-card-burning'
  },
  {
    name: 'ProfitYo App',
    category: 'Technology',
    description:
      'Technology solutions designed to streamline operations, automate workflows, and support business growth.',
    icon: FiIcons.FiCpu,
    tone: 'blue',
    position: 'ecosystem-card-app'
  },
  {
    name: 'Strategic Partnerships',
    category: 'Collaboration',
    description:
      'Relationships that expand capability, unlock resources, and create meaningful opportunities across the ecosystem.',
    icon: FiIcons.FiShare2,
    tone: 'slate',
    position: 'ecosystem-card-partnerships'
  },
  {
    name: 'Future Ventures',
    category: 'Innovation',
    description:
      'New businesses, products, and initiatives being developed for the next chapter of responsible growth.',
    icon: FiIcons.FiZap,
    tone: 'purple',
    position: 'ecosystem-card-future'
  }
];

function EcosystemCard({ item, index }) {
  return (
    <motion.article
      className={`ecosystem-overview-card ${item.position} tone-${item.tone}`}
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ delay: index * 0.08, duration: 0.5 }}
      whileHover={{ y: -8 }}
    >
      <div className="ecosystem-overview-card-top">
        <span className="ecosystem-overview-icon">
          <SafeIcon icon={item.icon} />
        </span>
        <span className="ecosystem-overview-number">0{index + 1}</span>
      </div>

      <span className="ecosystem-overview-category">{item.category}</span>
      <h3>{item.name}</h3>
      <p>{item.description}</p>

      <span className="ecosystem-overview-arrow">
        <SafeIcon icon={FiIcons.FiArrowUpRight} />
      </span>
    </motion.article>
  );
}

function EcosystemConnections() {
  return (
    <svg
      className="ecosystem-overview-connections"
      viewBox="0 0 1200 700"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="ecosystem-connection" x1="0" x2="1">
          <stop offset="0" stopColor="#d4af37" stopOpacity="0.1" />
          <stop offset="0.48" stopColor="#d4af37" stopOpacity="0.9" />
          <stop offset="1" stopColor="#2f80ed" stopOpacity="0.2" />
        </linearGradient>
      </defs>

      <line x1="600" y1="350" x2="200" y2="175" />
      <line x1="600" y1="350" x2="1000" y2="175" />
      <line x1="600" y1="350" x2="200" y2="525" />
      <line x1="600" y1="350" x2="1000" y2="525" />
      <line x1="600" y1="350" x2="600" y2="585" />

      <circle cx="600" cy="350" r="5" />
    </svg>
  );
}

export default function AboutEcosystem() {
  return (
    <div className="about-ecosystem-overview">
      <div className="ecosystem-overview-background" />
      <div className="ecosystem-overview-orbit ecosystem-overview-orbit-one" />
      <div className="ecosystem-overview-orbit ecosystem-overview-orbit-two" />

      <EcosystemConnections />

      <div className="ecosystem-overview-center">
        <span>ProfitYo</span>
        <strong>GLOBAL SYSTEM™</strong>
        <small>One vision · Many paths</small>
      </div>

      {ecosystemItems.map((item, index) => (
        <EcosystemCard key={item.name} item={item} index={index} />
      ))}
    </div>
  );
}